import type { ProgramNewsItemCounts, ProgramNewsItemStatus } from "@/services/adminProgramNews";
import Term from "./Term";
import CountTiles from "./CountTiles";

export type ArticleFilter = ProgramNewsItemStatus | "all";

interface ArticleStatusTilesProps {
  counts: Partial<ProgramNewsItemCounts>;
  active: ArticleFilter;
  onChange: (filter: ArticleFilter) => void;
}

const STATUSES: Array<{ key: ProgramNewsItemStatus; label: string; accent: string }> = [
  { key: "new", label: "New", accent: "text-amber-700" },
  { key: "suppressed", label: "Suppressed", accent: "text-muted-foreground" },
  { key: "classified", label: "Classified", accent: "text-green-700" },
  { key: "failed", label: "Failed", accent: "text-red-700" },
];

function numberOrNull(value: unknown): number | null {
  return typeof value === "number" ? value : null;
}

const ArticleStatusTiles = ({ counts, active, onChange }: ArticleStatusTilesProps) => {
  const known = STATUSES.map(({ key }) => numberOrNull(counts[key]));
  const total = known.every(value => value === null)
    ? null
    : known.reduce<number>((sum, value) => sum + (value ?? 0), 0);

  const tiles = [
    { key: "all" as const, label: "All", count: total },
    ...STATUSES.map(({ key, label, accent }) => ({
      key,
      label,
      accent,
      count: numberOrNull(counts[key]),
      renderLabel: (text: string) => <Term term={key}>{text}</Term>,
    })),
  ];

  return <CountTiles tiles={tiles} active={active} onChange={onChange} />;
};

export default ArticleStatusTiles;
